/**
 * @generated SignedSource<<43a8a228b6f57f00a3f7e8c57f7a3712>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateNavSectionInput = {
  id: string;
  title: string;
};
export type UpdateNavSectionButtonMutation$variables = {
  input: UpdateNavSectionInput;
};
export type UpdateNavSectionButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly title: string;
    } | null;
  };
};
export type UpdateNavSectionButtonMutation = {
  response: UpdateNavSectionButtonMutation$data;
  variables: UpdateNavSectionButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNavSectionResponse",
    "kind": "LinkedField",
    "name": "updateNavSection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSection",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateNavSectionButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateNavSectionButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2e361cfefba673b67bd9b07e8dc56116",
    "id": null,
    "metadata": {},
    "name": "UpdateNavSectionButtonMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateNavSectionButtonMutation(\n  $input: UpdateNavSectionInput!\n) {\n  response: updateNavSection(input: $input) {\n    node {\n      id\n      title\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51780c35a326d7fdaa12f170044924de";

export default node;
